module.exports = __webpack_public_path__ + "static/media/driving-clipart-auto-insurance-589723-4633234.1607216f.svg";